module.exports = __webpack_public_path__ + "f2d02c4f8ec176b41e7daea0b57c621f.jpg";